// @ts-nocheck


import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

import { fetchRequest } from './index';
import CommonApi from './../commonApi';

const convertDataFromServer = (month) => {
  return {
    ...month,
    economy: convertFromKopToRub(month.economy),
    economyResidue: convertFromKopToRub(month.economyResidue),
    plan: convertFromKopToRub(month.plan),
    need: convertFromKopToRub(month.need),
    fact: convertFromKopToRub(month.fact)
  };
};

const convertDataToServer = (month) => {
  return {
    ...month,
    economy: convertFromRubToKop(month.economy),
    economyResidue: convertFromRubToKop(month.economyResidue),
    plan: convertFromRubToKop(month.plan),
    need: convertFromRubToKop(month.need),
    fact: convertFromRubToKop(month.fact)
  };
};

const covertDataWriteOffToServer = (data) => {
  return {
    ...data,
    writeOff: convertFromRubToKop(data.writeOff)
  };
};

const baseUrl = 'branchBudgetSummaryMonth';
const branchBudgetSummaryMonth = new CommonApi(
  baseUrl,
  'Бюджет свод',
  convertDataToServer,
  convertDataFromServer
);

const writeOff = async (data) => {
  const updated = await fetchRequest.put(
    `/${baseUrl}/writeOff`,
    covertDataWriteOffToServer(data)
  );
  if (updated) return updated;
  throw new Error('Не удалось обновить');
};

export default { ...branchBudgetSummaryMonth, writeOff };
